import { observable, action } from 'mobx';
import ywk from '@clouderwork/ywk';
import { IUserInfo, IBaseData } from '../../entity/user';
import mobxState from '@src/store';
import { urlFn } from '@src/utils/index';
import { Toast } from 'antd-mobile';
import { toLogin } from '@src/utils/helper';
import * as dd from 'dingtalk-jsapi';

class User {
  constructor() {
    console.log('constructor:', dd.env.platform);
    if (dd.env.platform === 'notInDingTalk') {
      const flag = urlFn.getFirstPathName();
      if (flag === 'monitor' || flag == 'monitorsub') {
        this.getProfile();
        this.getBasicData();
      }
    } else {
      this.requestAuthCode();
    }
  }

  // 当前用户信息
  @observable
  curUserInfo!: IUserInfo;

  @observable baseData: IBaseData = {};
  /**
   * 设置当前用户信息
   * @param user 用户信息
   */
  @action.bound
  setUserInfo(user: IUserInfo) {
    this.curUserInfo = user;
  }

  @action.bound
  async requestAuthCode() {
    const self = this;
    const corpId = ywk.utils.getQueryString('corpId') || sessionStorage.getItem('corpId') || '';
    if (corpId) {
      sessionStorage.setItem('corpId', corpId);
    }

    if (dd.env.platform !== 'notInDingTalk') {
      dd.ready(function () {
        dd.runtime.permission.requestAuthCode({
          corpId,
          onSuccess(result: { code: string }) {
            self.authFn(result.code, corpId);
          },
          onFail(err) {
            window.location.href = '/mobile/norole';
            alert(`onFail, dd error: ${JSON.stringify(err)}`);
          }
        });
      });
    } else {
      this.getProfile();
    }
  }

  @action.bound
  async authFn(code, corpId) {
    const res = await ywk.ajax.post('/monitor/api/dingtalk/auth', {
      corpid: corpId,
      code
    });

    if (res.error_code === 0) {
      ywk.cookie.set('cwsso_token', res.data.token);
      this.getProfile();
    } else {
      window.location.href = '/mobile/norole?msg=' + res.msg;
    }
  }

  /**
   * 获取用户信息
   *
   * @returns
   * @memberof User
   */
  @action.bound
  async getProfile() {
    const res = await ywk.ajax.getJson('/monitor/api/user');
    if (res.error_code === 0) {
      this.curUserInfo = res;
      mobxState.monitor.department.setSelectUser({
        avatar: res.avatar,
        name: res.name || res.nickname,
        id: res.id,
        uuid: res.uuid
      });
    } else {
      // 未登录
      if (res.response.status === 403 || (res.response.data && +res.response.data.error_code === 80001)) {
        // toLogin();
      }
    }
  }
  // 储存公用常量数据
  @action.bound
  async getBasicData() {
    const res = await ywk.ajax.getJson('/monitor/api/params');
    if (res.error_code === 0) {
      this.baseData = res.params;
    }
  }
}

export default User;
